module.exports = __webpack_public_path__ + "img/Phone_01.9b1b4607.jpg";